import { render, staticRenderFns } from "./NavbarIcon.vue?vue&type=template&id=737775c8&scoped=true&"
import script from "./NavbarIcon.vue?vue&type=script&lang=ts&"
export * from "./NavbarIcon.vue?vue&type=script&lang=ts&"
import style0 from "./NavbarIcon.vue?vue&type=style&index=0&id=737775c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737775c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('737775c8', component.options)
    } else {
      api.reload('737775c8', component.options)
    }
    module.hot.accept("./NavbarIcon.vue?vue&type=template&id=737775c8&scoped=true&", function () {
      api.rerender('737775c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/NavbarIcon.vue"
export default component.exports